import { useMemo } from 'react';
import { theme as antdTheme, type ThemeConfig } from 'antd';
import { useTheme } from 'styled-components';

/** The antd pieces of the board, dark: left alone, antd draws its own light palette next to the rest of the board. */
export function useAntdDarkTheme(): ThemeConfig {
  const theme = useTheme();

  return useMemo(
    () => ({
      algorithm: antdTheme.darkAlgorithm,
      token: {
        colorBgElevated: theme.colors.neutral.palette800,
        colorBorder: theme.colors.neutral.palette700,
        colorText: theme.colors.neutral.white,
      },
    }),
    [theme]
  );
}
